import { render } from "./FormCheckbox.vue?vue&type=template&id=6047b856&bindings={\"modelValue\":\"props\",\"required\":\"props\",\"config\":\"props\",\"uuid\":\"props\",\"label\":\"props\",\"fieldClasses\":\"props\",\"update\":\"options\"}"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script